var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_88454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 2,
    width: 24,
    height: 28,
    rx: 2,
    fill: "url(#paint0_linear_5259_88454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 23H32.5V28C32.5 29.1046 31.6046 30 30.5 30H10.5C9.39543 30 8.5 29.1046 8.5 28V23Z",
    fill: "url(#paint1_linear_5259_88454)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 16,
    width: 24,
    height: 7,
    fill: "url(#paint2_linear_5259_88454)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 9,
    width: 24,
    height: 7,
    fill: "url(#paint3_linear_5259_88454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12C8.5 10.3431 9.84315 9 11.5 9H17.5C19.1569 9 20.5 10.3431 20.5 12V24C20.5 25.6569 19.1569 27 17.5 27H8.5V12Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#paint4_linear_5259_88454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.0142H13.5523L12.0229 17.539L10.3497 11H8.70261L7.01634 17.539L5.5 11.0142H3.5L6.10131 21H7.8268L9.5 14.6879L11.1732 21H12.8987L15.5 11.0142Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5259_88454",
    x1: 8.5,
    y1: 6.66667,
    x2: 32.5,
    y2: 6.66667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5259_88454",
    x1: 8.5,
    y1: 27.375,
    x2: 32.5,
    y2: 27.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5259_88454",
    x1: 19,
    y1: 20,
    x2: 32.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20478B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5259_88454",
    x1: 19,
    y1: 13,
    x2: 32.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E84D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5259_88454",
    x1: 0.5,
    y1: 17,
    x2: 19.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215091"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_88454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsWord);
export default __webpack_public_path__ + "static/media/MsWord.b3f7550705a635b2512ba20266fcf0b2.svg";
export { ForwardRef as ReactComponent };